module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/441.fe929e9b.png";